import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import Currency from 'react-currency-formatter';
import { PriceContext } from '../../contexts/PriceContext';
import { WardrobesConfigsContext } from '../../contexts/WardrobesConfigsContext';
import { ActiveWardrobeContext } from '../../contexts/ActiveWardrobeContext';
import calculatePrice from '../../helpers/calculatePrice';

function useChangeMaterial(colorsList, colorName, changeMaterial, wardrobesConfigs) {
  const [wardrobesConfigsString, setWardrobesConfigString] = React.useState('');

  React.useEffect(() => {
    if (wardrobesConfigsString !== JSON.stringify(wardrobesConfigs)) {
      setWardrobesConfigString(JSON.stringify(wardrobesConfigs));
      const color = colorsList.find(item => item.slug === colorName);
      if (color) {
        changeMaterial(color);
      }
    }
  }, [changeMaterial, colorName, colorsList, wardrobesConfigs, wardrobesConfigsString]);
}

const ColorsListItem = props => {
  const { colorName, colorsList, changeMaterial } = props;

  const { wardrobesConfigs } = useContext(WardrobesConfigsContext);
  const { activeWardrobe } = useContext(ActiveWardrobeContext);
  const { setPrice } = useContext(PriceContext);

  const wardrobe = wardrobesConfigs[activeWardrobe];

  const handleClick = React.useCallback(
    item => {
      changeMaterial(item);
      setPrice(calculatePrice(wardrobe));
    },
    [changeMaterial, setPrice, wardrobe],
  );

  useChangeMaterial(colorsList, colorName, handleClick, wardrobe);

  return (
    <div className="color-list__box">
      {colorsList.map((item, key) =>
        colorsList.length === 0 ? null : (
          <div className="color-list__item" key={'color-list-item_' + key}>
            <button
              className={`color-list__button ${item.slug === colorName ? 'active' : ''}`}
              onClick={() => handleClick(item)}>
              <span
                className="color-list__img"
                style={{ backgroundImage: `url("${item.icon ?? item.img}")` }}
                title={item.name ?? item.safo}
              />
              <span className="color-list__price">
                <Currency quantity={item.price.actual} currency="PLN" />
              </span>
            </button>
          </div>
        ),
      )}
    </div>
  );
};

ColorsListItem.propTypes = {
  colorName: PropTypes.string,
  colorsList: PropTypes.array,
};

export default ColorsListItem;
